import React, { FC } from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import CountUp from 'react-countup';
import Button from '@src/components/LegacyButton';
import CandidatesSvg from '@src/svgs/candidates.svg';
import './styles.scss';

export const MatchingCandidates: FC = ({ label, showButton, onButtonClick, matchesCount, oldMatchesCount }) => {
  return (
    <div className="matching-candidates">
      <div className="matching-candidates-data">
        <Svg src={CandidatesSvg} />

        {matchesCount !== undefined ? (
          <CountUp className="matching-candidates-reach" end={matchesCount} start={oldMatchesCount} />
        ) : (
          <span className="matching-candidates-reach">Loading...</span>
        )}

        {showButton && (
          <Button className="matching-candidates-button" onClick={onButtonClick} style="secondary">
            VIEW
          </Button>
        )}
      </div>

      <div className="matching-candidates-label">{label}</div>
    </div>
  );
};

MatchingCandidates.propTypes = {
  label: PropTypes.string.isRequired,
  matchesCount: PropTypes.number,
  oldMatchesCount: PropTypes.number,
  onButtonClick: PropTypes.func,
  showButton: PropTypes.bool,
};

MatchingCandidates.defaultProps = {
  showButton: false,
};
